import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Hearts = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.222 12.506a7.1 7.1 0 0 0 3.218-4.528 3.6 3.6 0 0 0-2.81-4.021 3.3 3.3 0 0 0-3.276 1.635 3.29 3.29 0 0 0-2.763-2.4 3.6 3.6 0 0 0-3.726 3.186 5.06 5.06 0 0 0 .26 2.263m2.67.673a3.66 3.66 0 0 0-2.742 3 3.65 3.65 0 0 0-3.82-1.388 4 4 0 0 0-2.588 4.789c1.054 4.291 7.812 6.33 8.743 6.1.93-.23 5.975-5.167 4.92-9.458A4 4 0 0 0 11.8 9.314z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Hearts) as SvgIcon;
export { ForwardRef as ReactComponent };
